import { SafetyCertificateFilled, UserAddOutlined, UserDeleteOutlined, UserOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Alert, Form, Popconfirm, Select, Space, Table, Typography } from 'antd';
import React from 'react';
import { IconButton, roleLabel, useFeedback, UserSelect } from '../../components/ResourcePlanning/shared';
import api from '../../services/resourcePlanning/ResourcePlanningService';

const ROLE_OPTIONS = ['TechnicalDirector', 'PlanningManager'].map((role) => ({
  value: role,
  label: (
    <Space size={6}>
      {role === 'TechnicalDirector' ? <SafetyCertificateFilled style={{ color: '#1677ff' }} /> : <UserOutlined />}
      {roleLabel(role)}
    </Space>
  ),
}));

const AccessTab: React.FC = () => {
  const { data = [], isLoading, error } = useQuery({ queryKey: ['resourcePlanning', 'roles'], queryFn: api.roles });
  const [form] = Form.useForm();
  const feedback = useFeedback();
  const run = useMutation({
    mutationFn: ({ userId, role }: { userId: string; role: string | null }) => api.assignRole(userId, role),
    onSuccess: () => {
      form.resetFields();
      feedback.success('Acces actualizat.');
    },
    onError: feedback.error,
  });
  return (
    <Space direction='vertical' size='middle' style={{ width: '100%' }}>
      <Alert
        type='info'
        showIcon
        message='Directorul tehnic controleaza intreaga planificare. Responsabilii pot gestiona echipe, proiecte si alocari. Desemnarea unui director nou inlocuieste directorul existent.'
      />
      <Form
        form={form}
        layout='inline'
        onFinish={(values) => run.mutate(values)}
        initialValues={{ role: 'PlanningManager' }}
        style={{ rowGap: 12 }}
      >
        <Form.Item name='userId' label='Utilizator' rules={[{ required: true }]}>
          <UserSelect all />
        </Form.Item>
        <Form.Item name='role' label='Rol' rules={[{ required: true }]}>
          <Select style={{ width: 250 }} options={ROLE_OPTIONS} />
        </Form.Item>
        <Form.Item>
          <IconButton
            title='Atribuie rol'
            htmlType='submit'
            type='primary'
            icon={<UserAddOutlined />}
            loading={run.isPending}
          />
        </Form.Item>
      </Form>
      {error && <Typography.Text type='danger'>{(error as Error).message}</Typography.Text>}
      <Table
        rowKey='userId'
        loading={isLoading}
        dataSource={data}
        columns={[
          { title: 'Utilizator', dataIndex: 'userName' },
          {
            title: 'Rol',
            width: 280,
            render: (_, row) => (
              <Select
                value={row.role}
                style={{ width: 250 }}
                options={ROLE_OPTIONS}
                disabled={run.isPending}
                onChange={(role) => run.mutate({ userId: row.userId, role })}
              />
            ),
          },
          {
            title: '',
            width: 60,
            render: (_, row) => (
              <Popconfirm
                title='Retrageti accesul la planificare?'
                onConfirm={() => run.mutate({ userId: row.userId, role: null })}
              >
                <IconButton
                  title='Retrage accesul'
                  danger
                  size='small'
                  icon={<UserDeleteOutlined />}
                  loading={run.isPending}
                />
              </Popconfirm>
            ),
          },
        ]}
      />
    </Space>
  );
};
export default AccessTab;
